module.exports = __webpack_public_path__ + "img/underthebridge.7e6ab5f4.jpg";